module.exports = __webpack_public_path__ + "static/media/12.ef5475c7.jpg";